import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IClientState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const administrationModule: Module<IClientState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default administrationModule
